import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  updateDoc,
  increment,
} from "firebase/firestore";
import {
  FaCalendarAlt,
  FaClock,
  FaFacebookF,
  FaWhatsapp,
  FaTelegramPlane,
   FaShareAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const VideoDetails = () => {
  const { id } = useParams();

  const [video, setVideo] = useState(null);
  const [relatedVideos, setRelatedVideos] = useState([]);

  // =========================
  // YOUTUBE ID
  // =========================
  const getYoutubeId = (url) => {
    if (!url) return "";

    try {
      const parsed = new URL(url);

      if (parsed.hostname.includes("youtu.be")) {
        return parsed.pathname.substring(1);
      }

      if (parsed.hostname.includes("youtube.com")) {
        const v = parsed.searchParams.get("v");

        if (v) return v;

        if (parsed.pathname.includes("/shorts/")) {
          return parsed.pathname.split("/shorts/")[1];
        }

        if (parsed.pathname.includes("/embed/")) {
          return parsed.pathname.split("/embed/")[1];
        }
      }
    } catch (error) {
      return "";
    }

    return "";
  };

  // =========================
  // LOAD VIDEO
  // =========================
  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const videoRef = doc(db, "videos", id);
        const snap = await getDoc(videoRef);

        if (!snap.exists()) {
          return;
        }

        const videoData = {
          id: snap.id,
          ...snap.data(),
        };

        setVideo(videoData);


      
// RELATED VIDEOS
// =========================
if (videoData.category) {
  const q = query(
    collection(db, "videos"),
    where("category", "==", videoData.category)
  );

  const relatedSnap = await getDocs(q);

  const related = relatedSnap.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
    .filter((item) => item.id !== id)
    .sort((a, b) => {
      const timeA = a.timestamp?.seconds || 0;
      const timeB = b.timestamp?.seconds || 0;

      return timeB - timeA;
    })
    .slice(0, 4);

  setRelatedVideos(related);
}
      } catch (error) {
        console.error("Video details error:", error);
      }
    };

    fetchVideo();
  }, [id]);

  if (!video) {
    return (
      <div
        style={{
          padding: "50px",
          textAlign: "center",
        }}
      >
        ভিডিও লোড হচ্ছে...
      </div>
    );
  }

  const youtubeId = getYoutubeId(video.youtubeUrl);

  const currentUrl =
    window.location.origin + `/video/${video.id}`;

  const shareLinks = {
    facebook:
      `https://www.facebook.com/sharer/sharer.php?u=` +
      encodeURIComponent(currentUrl),

    twitter:
      `https://twitter.com/intent/tweet?url=` +
      encodeURIComponent(currentUrl) +
      `&text=` +
      encodeURIComponent(video.title),

    whatsapp:
      `https://api.whatsapp.com/send?text=` +
      encodeURIComponent(
        video.title + " - " + currentUrl
      ),

    telegram:
      `https://t.me/share/url?url=` +
      encodeURIComponent(currentUrl) +
      `&text=` +
      encodeURIComponent(video.title),
  };

  return (
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "30px",
          alignItems: "flex-start",
        }}
      >

        {/* =========================
            LEFT SIDEBAR
        ========================= */}
        <aside
          style={{
            width: "18%",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              borderLeft: "5px solid #d2202a",
              paddingLeft: "15px",
              marginBottom: "25px",
            }}
          >
            <Link
              to="/video"
              style={{
                textDecoration: "none",
                fontSize: "22px",
                fontWeight: "bold",
                color: "#000",
              }}
            >
              ভিডিও
            </Link>
          </div>

          <h4
            style={{
              borderBottom:
                "2px solid #d2202a",
              paddingBottom: "5px",
              color: "#000",
              fontSize: "20px",
              marginBottom: "20px",
            }}
          >
            এ সম্পর্কিত আরো ভিডিও
          </h4>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {relatedVideos.map((item) => {
              const thumb =
                item.thumbnail ||
                `https://img.youtube.com/vi/${getYoutubeId(
                  item.youtubeUrl
                )}/hqdefault.jpg`;

              return (
                <Link
  key={item.id}
  to={`/video/${item.id}`}
  style={{
    textDecoration: "none",
    color: "#333",
    display: "block",
    padding: "8px",
    borderRadius: "6px",
    background: "#fff",
    transform: "translateY(0)",
    boxShadow: "none",
    transition: "all 0.2s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#f4f9ff";
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow =
      "0 4px 12px rgba(0,0,0,0.08)";

    const title = e.currentTarget.querySelector(".related-video-title");
    if (title) {
      title.style.color = "#4169E1";
    }
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#fff";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";

    const title = e.currentTarget.querySelector(".related-video-title");
    if (title) {
      title.style.color = "#333";
    }
  }}
>
  <img
    src={thumb}
    alt={item.title}
    style={{
      width: "100%",
      height: "100px",
      objectFit: "cover",
      borderRadius: "5px",
      marginBottom: "5px",
      display: "block",
    }}
  />

  <div
    className="related-video-title"
    style={{
      fontSize: "15px",
      fontWeight: "bold",
      lineHeight: "1.4",
      color: "#333",
      transition: "color 0.2s ease",
    }}
  >
    {item.title}
  </div>
</Link>
              );
            })}
          </div>
        </aside>

        {/* =========================
            MAIN CONTENT
        ========================= */}
        <main
          style={{
            flexGrow: 1,
            maxWidth: "850px",
          }}
        >
          <h1
            style={{
              fontSize: "34px",
              lineHeight: "1.35",
              marginBottom: "15px",
            }}
          >
            {video.title}
          </h1>

          {/* META */}
          <div
            style={{
              display: "flex",
              justifyContent:
                "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              {video.reporterName && (
                <span
                  style={{
                    fontSize: "14px",
                    color: "#0056b3",
                    fontWeight: "bold",
                  }}
                >
                  {video.reporterName}
                </span>
              )}

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  color: "#777",
                  fontSize: "13px",
                }}
              >
                <span>
                  <FaCalendarAlt />{" "}
                  {video.timestamp
                    ? new Date(
                        video.timestamp.seconds *
                          1000
                      ).toLocaleDateString(
                        "bn-BD",
                        {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        }
                      )
                    : ""}
                </span>

                <span>
                  <FaClock />{" "}
                  {video.timestamp
                    ? new Date(
                        video.timestamp.seconds *
                          1000
                      ).toLocaleTimeString(
                        "bn-BD",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )
                    : ""}
                </span>
              </div>
            </div>

          {/* SHARE */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  }}
>
  {/* Share Label */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      marginRight: "3px",
      color: "#555",
      fontSize: "14px",
      fontWeight: "600",
    }}
  >
    <FaShareAlt />
    <span>শেয়ার করুন</span>
  </div>

  {/* Facebook */}
  <a
    href={shareLinks.facebook}
    target="_blank"
    rel="noopener noreferrer"
    title="Facebook-এ শেয়ার করুন"
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      background: "#1877F2",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.boxShadow =
        "0 4px 10px rgba(24,119,242,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <FaFacebookF />
  </a>

  {/* X */}
  <a
    href={shareLinks.twitter}
    target="_blank"
    rel="noopener noreferrer"
    title="X-এ শেয়ার করুন"
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      background: "#000",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.boxShadow =
        "0 4px 10px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <FaXTwitter />
  </a>

  {/* WhatsApp */}
  <a
    href={shareLinks.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    title="WhatsApp-এ শেয়ার করুন"
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      background: "#25D366",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.boxShadow =
        "0 4px 10px rgba(37,211,102,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <FaWhatsapp />
  </a>

  {/* Telegram */}
  <a
    href={shareLinks.telegram}
    target="_blank"
    rel="noopener noreferrer"
    title="Telegram-এ শেয়ার করুন"
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      background: "#229ED9",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.style.boxShadow =
        "0 4px 10px rgba(34,158,217,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
  >
    <FaTelegramPlane />
  </a>
</div>
</div>
          {/* =========================
              YOUTUBE VIDEO
          ========================= */}
          <div
            style={{
              position: "relative",
              width: "100%",
              aspectRatio: "16 / 9",
              background: "#000",
              borderRadius: "8px",
              overflow: "hidden",
              marginBottom: "20px",
            }}
          >
            {youtubeId && (
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${youtubeId}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  position: "absolute",
                  inset: 0,
                }}
              />
            )}
          </div>

          {/* DESCRIPTION */}
          {video.description && (
            <div
              style={{
                fontSize: "19px",
                lineHeight: "1.8",
                color: "#333",
                textAlign: "justify",
                marginBottom: "25px",
                whiteSpace: "pre-line",
              }}
            >
              {video.description}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default VideoDetails;